<template>
  <div>
    <div class="cloak cloak-right cloak-mobile iconfont">&#xe64c;</div>
    <input type="search" placeholder="极客搜索" v-model="value" @focus="searchOff()" @blur="searchOff()" @keyup.13="searchOn(value)">
  </div>
</template>
<script>
export default {
  data () {
    return {
      value: ''
    }
  },
  methods: {
    searchOff () {
      this.isShowNav = !this.isShowNav
      this.$emit('searchDisplay')
    }
  }
}
</script>
<style lang="sass" scoped>
  .iconfont
    display: inline-block
    color: #fff
    margin-top: 3px
  .cloak-mobile
    background-color: initial
    left: 0
    font-size: 14px
  input
    border-radius: 14px
    border: none
    height: 28px
    position: absolute
    outline: none
    opacity: 1
    width: 100%
    background-color: transparent
    padding-left: .8rem
    color: #fff
    font-size: 14px
  input::-webkit-search-cancel-button
    display: none
  input::-webkit-input-placeholder  /* WebKit, Blink, Edge */
    font-size: 14px
    color: #888
  input:-moz-placeholder  /* Mozilla Firefox 4 to 18 */
    font-size: 14px
    color: #888

  input::-moz-placeholder  /* Mozilla Firefox 19+ */
    font-size: 14px
    color: #888
  input:-ms-input-placeholder /* Internet Explorer 10-11 */
    font-size: 14px
    color: #888

</style>
